import { Injectable } from '@angular/core';

import { UserRoles } from '@xbs/xbs-enums';

import { SessionService } from './session.service';
import { UserPermissionsPolicy } from '../models/user-permissions-policy';

@Injectable({
  providedIn: 'root'
})
export class UserPermissionsService {

  private userRoles;

  constructor(private _sessionService: SessionService) {
    this.userRoles = UserRoles;
  }

  public createUserPermissionsPolicy(allowedRoles: string[]): UserPermissionsPolicy {
    const userPermissionsPolicy = new UserPermissionsPolicy();

    allowedRoles.forEach(role => {
      if (this.doesUserRoleExist(role)) {
        userPermissionsPolicy[role] = true;
      }
    });

    return userPermissionsPolicy;
  }

  public userHasPermissions(policy: UserPermissionsPolicy): boolean {
    const currentUserRole = this._sessionService.getUserRole();
    const roleHasPermissions = policy[currentUserRole] === true;

    return roleHasPermissions;
  }

  private doesUserRoleExist(userRole: string): boolean {
    const roleExists = Object.values(this.userRoles.ByName).some((role: any) => {
      return role.Value === userRole;
    });

    return roleExists;
  }

}
